import { Box, Button } from "@mui/material";

export default function Calculate(props) {
  const { submit } = props;

  return (
    <>
      <Box
        sx={{
          marginY: 5
        }}>
        <Button
          color='secondary'
          variant='contained'
          size="large"
          onClick={submit}
          sx={(theme) => ({
            width: '100%',
            maxWidth: 400,
            borderRadius: '8px',
            backgroundColor: theme.palette.primary.main
          })}
        >Calculate</Button>
      </Box>
    </>
  );
}